import type { Client } from '@urql/core'
import { graphql } from 'app/generated/gql'

import type { FormFieldMapping as FormFieldMappingType, FormFieldMappingListResult } from 'app/generated/graphql'
import { EntityStore } from './EntityStore'

const FORM_FIELD_MAPPING_FIELDS = `createdDate formField id orgId rawKey updatedDate version workspaceId`

const LIST_QUERY = graphql(`
  query FormFieldMappings($search: String, $pagination: PaginationInput, $sort: SortInput) {
    formFieldMappings(search: $search, pagination: $pagination, sort: $sort) {
      hits {
        createdDate
        formField
        id
        orgId
        rawKey
        updatedDate
        version
        workspaceId
      }
      total
      page
    }
  }
`)

const CREATE_MUTATION = graphql(`
  mutation CreateFormFieldMappingStore($input: CreateFormFieldMappingInput!) {
    createFormFieldMapping(input: $input) {
      createdDate
      formField
      id
      orgId
      rawKey
      updatedDate
      version
      workspaceId
    }
  }
`)

const UPDATE_MUTATION = graphql(`
  mutation UpdateFormFieldMappingStore($id: ID!, $input: UpdateFormFieldMappingInput!) {
    updateFormFieldMapping(id: $id, input: $input) {
      createdDate
      formField
      id
      orgId
      rawKey
      updatedDate
      version
      workspaceId
    }
  }
`)

const DELETE_MUTATION = graphql(`
  mutation DeleteFormFieldMapping($id: ID!) {
    deleteFormFieldMapping(id: $id)
  }
`)

export class FormFieldMappingStore extends EntityStore<
  FormFieldMappingType,
  FormFieldMappingListResult,
  typeof CREATE_MUTATION,
  typeof UPDATE_MUTATION
> {
  constructor(client: Client) {
    super(client, {
      listQuery: LIST_QUERY,
      getQuery: undefined,
      createMutation: CREATE_MUTATION,
      updateMutation: UPDATE_MUTATION,
      deleteMutation: DELETE_MUTATION,
      typename: `FormFieldMapping`,
      extractList: (data: any) => data.formFieldMappings,
      extractMutated: (data: any) => data.updateFormFieldMapping ?? data.createFormFieldMapping,
    })
  }
}
